module.exports = __webpack_public_path__ + "static/media/login-green.e870255d.png";